// src/contexts/AuthContext.tsx

import { FinancialData } from 'app/pages/Networth/slice/types';
import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
  useEffect,
} from 'react';

interface NetworthContextType {
  login: boolean;
  menu: boolean;
  toggleMenu: () => void;
  closeMenu: () => void;
  modal: boolean;
  toogleModal: () => void;
  setAssets: (assets: string) => void;
  setLiabilities: (liabilities: string) => void;
  assetsValue: string;
  liabilitiesValue: string;
  networthValue: string;
  setNetworth: (networth: string) => void;
  setdata: (data: FinancialData) => void;
  data: FinancialData;

  isGroup: boolean;
  setIsGroup: (val: boolean) => void;
}

const NetworthContext = createContext<NetworthContextType | undefined>(
  undefined,
);

// Create a provider component
export const NetworthProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isLogin, setIsLogin] = useState<boolean>(true);
  const [showMenu, setShowMenu] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  // State for assets and liabilities
  const [assets, setAssets] = useState('0');
  const [liabilities, setLiabilities] = useState('0');

  const [networth, setNetworth] = useState('0');

  const [data, setData] = useState<FinancialData>({
    total_networth: 0,
    assets_worth: 0,
    liabilities_worth: 0,
    assets_overview: {
      gold: {
        invested_value: 0,
        current_value: 0,
        risk_profile_score: 0,
        returns_in_percentage: 0,
        details: [],
      },
      etf: {
        invested_value: 0,
        current_value: 0,
        risk_profile_score: 0,
        returns_in_percentage: 0,
        details: [],
      },
      unlisted_shares: {
        invested_value: 0,
        current_value: 0,
        risk_profile_score: 0,
        returns_in_percentage: 0,
        details: [],
      },
      government_securities: {
        invested_value: 0,
        current_value: 0,
        risk_profile_score: 0,
        returns_in_percentage: 0,
        details: [],
      },
      fixed_deposits: {
        invested_value: 0,
        current_value: 0,
        risk_profile_score: 0,
        returns_in_percentage: 0,
        details: [],
      },
      mutual_funds: {
        invested_value: 0,
        current_value: 0,
        risk_profile_score: 0,
        returns_in_percentage: 0,
        details: [],
      },
      stocks: {
        invested_value: 0,
        current_value: 0,
        risk_profile_score: 0,
        returns_in_percentage: 0,
        details: [],
      },
      real_estate: {
        invested_value: 0,
        current_value: 0,
        risk_profile_score: 0,
        returns_in_percentage: 0,
        details: [],
      },
      gold_jewellery: {
        invested_value: 0,
        current_value: 0,
        risk_profile_score: 0,
        returns_in_percentage: 0,
        details: [],
      },
      platinum: {
        invested_value: 0,
        current_value: 0,
        risk_profile_score: 0,
        returns_in_percentage: 0,
        details: [],
      },
      sgb: {
        invested_value: 0,
        current_value: 0,
        risk_profile_score: 0,
        returns_in_percentage: 0,
        details: [],
      },
      epf_and_ppf: {
        invested_value: 0,
        current_value: 0,
        risk_profile_score: 0,
        returns_in_percentage: 0,
        details: [],
      },
      other_metals: {
        invested_value: 0,
        current_value: 0,
        risk_profile_score: 0,
        returns_in_percentage: 0,
        details: [],
      },
      bond: {
        invested_value: 0,
        current_value: 0,
        risk_profile_score: 0,
        returns_in_percentage: 0,
        details: [],
      },
      savings: {
        invested_value: 0,
        current_value: 0,
        risk_profile_score: 0,
        returns_in_percentage: 0,
        details: [],
      },
      current: {
        invested_value: 0,
        current_value: 0,
        risk_profile_score: 0,
        returns_in_percentage: 0,
        details: [],
      },
      fixed_deposit: {
        invested_value: 0,
        current_value: 0,
        risk_profile_score: 0,
        returns_in_percentage: 0,
        details: [],
      },
      recurring_deposit: {
        invested_value: 0,
        current_value: 0,
        risk_profile_score: 0,
        returns_in_percentage: 0,
        details: [],
      },
      EPF: {
        invested_value: 0,
        current_value: 0,
        risk_profile_score: 0,
        returns_in_percentage: 0,
        details: [],
      },

      commodities: {
        invested_value: 0,
        current_value: 0,
        risk_profile_score: 0,
        returns_in_percentage: 0,
        details: [],
      },
      crypto: {
        invested_value: 0,
        current_value: 0,
        risk_profile_score: 0,
        returns_in_percentage: 0,
        details: [],
      },
      forex: {
        invested_value: 0,
        current_value: 0,
        risk_profile_score: 0,
        returns_in_percentage: 0,
        details: [],
      },
      other: {
        invested_value: 0,
        current_value: 0,
        risk_profile_score: 0,
        returns_in_percentage: 0,
        details: [],
      },
      others: {
        invested_value: 0,
        current_value: 0,
        risk_profile_score: 0,
        returns_in_percentage: 0,
        details: [],
      },
      gold_coins: {
        invested_value: 0,
        current_value: 0,
        risk_profile_score: 0,
        returns_in_percentage: 0,
        details: [],
      },
    },
    asset_distribution: {
      gold: 0,
      fixed_deposits: 0,
      mutual_funds: 0,
      stocks: 0,
    },
    debts: [],
    income_expense_ratio: null,
    days_pnl: null,
  });

  const [isGroup, setIsGroup] = useState<boolean>(
    localStorage.getItem('isGroup') === 'true',
  );

  useEffect(() => {
    if (isGroup) {
      localStorage.setItem('isGroup', 'true');
    } else {
      localStorage.removeItem('isGroup');
    }
  }, [isGroup]);

  const toggleMenu = () => {
    setShowMenu(prev => !prev);
  };

  const closeMenu = () => {
    setShowMenu(false);
  };
  const toogleModal = () => {
    setShowModal(prev => !prev);
  };

  const updateAssets = (newAssets: string) => {
    setAssets(newAssets);
  };

  const updateLiabilities = (newLiabilities: string) => {
    setLiabilities(newLiabilities);
  };
  const updateNetworth = (newNetworth: string) => {
    setNetworth(newNetworth);
  };

  return (
    <NetworthContext.Provider
      value={{
        login: isLogin,
        menu: showMenu,
        modal: showModal,
        toggleMenu,
        closeMenu,
        toogleModal,
        setAssets: updateAssets,
        assetsValue: assets,
        setLiabilities: updateLiabilities,
        liabilitiesValue: liabilities,
        setNetworth: updateNetworth,
        networthValue: networth,
        setdata: setData,
        data: data,
        isGroup,
        setIsGroup,
      }}
    >
      {children}
    </NetworthContext.Provider>
  );
};

export const useNetworth = (): NetworthContextType => {
  const context = useContext(NetworthContext);
  if (context === undefined) {
    throw new Error('useNetworth must be used within a NetworthProvider');
  }
  return context;
};
